<template lang="pug">
  .desktop-student
    course-list-filter-block(
      no-mounted-emit
      @filters:update="routeToCourses($event)"
    ).mb-8

    v-row
      v-col(lg="8" md="6" cols="12" order=1)
        h3 Обучение
        p Курсы, где я обучаюсь
        v-row().mb-4
          v-col(cols=12 v-if="!$loader.isLoading && !courses.length")
            p Вы еще нигде не обучаетесь...
          v-col.mb-2(
            xl="4" lg="6" md="12" cols="12"
            v-for="(course, i) in courses"
            v-if="course.priority_user_prior_record"
            :key="course.id"
          )
            record-status-wrap(
              :user-record="course.priority_user_prior_record.user_record"
              v-slot:default="{ color, label, group }"
            )
              .d-flex.flex-column.fill-height
                .pb-1
                  v-avatar(size="12" :color="color || 'grey'").mr-2
                  span.text-body-2 {{ label}}
                course-card(
                  :course="course"
                  :group="group"
                  outlined
                  study
                )
      v-col(lg="4" md="6" cols="12" :order="isMobile ? '-1' : '2'")
        LessonsCalendar

</template>

<script>
import { STATUSES } from '@/modules/CourseManagement/constants';
import LessonsCalendar from '@/modules/Education/Schedule/components/LessonsCalendar.vue';

import RecordStatusWrap from '@/components/Enrollment/RecordStatusWrap.vue';
import CourseListFilterBlock from '@/modules/Courses/components/CourseListFilterBlock.vue';
import CourseCard from '@/modules/Courses/components/CourseCard.vue';
import NearestTranslations from './Widgets/NearestTranslations.vue';

export default {
  name: 'DesktopStudent',
  components: {
    LessonsCalendar,
    RecordStatusWrap,
    NearestTranslations,
    CourseCard,
    CourseListFilterBlock,
  },
  data: () => ({
    courses: [],

    STATUSES,
  }),
  computed: {
    isMobile() {
      return !this.$vuetify.breakpoint.mdAndUp;
    },
  },
  created() {
    this.fetchCourses();
  },
  methods: {
    async fetchCourses() {
      const params = {};

      params['search[contracted_or_requested]'] = true;
      params.expand = 'organizations,edit,type_activity_name,user_group_id,course_units_count,priority_user_prior_record';

      this.$loader.start({ target: true });
      await this.$rHandler(
        this.$api.courses.getCourseList(params),
        (resp) => {
          this.courses = resp.data.data;
        },
      );
      this.$loader.stop();
    },
    routeToCourses(query = {}) {
      this.$router.push({ name: 'CourseList', query });
    },
  },
};
</script>
